import { Flex } from 'foundations-components/components/Flex';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { Small } from 'foundations-components/transitional/components/Small';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { useContext } from 'react';
import { ContactsPropsContext } from '../../contexts/contacts/PropsContext';
import Avatar from '../common/Avatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SuggestionsListRow({
  email,
  name,
  checked,
  contactId
}) {
  const {
    apiWrapper,
    portalId
  } = useContext(ContactsPropsContext);
  return /*#__PURE__*/_jsx(MediaObject, {
    align: "center",
    itemLeft: /*#__PURE__*/_jsx(Avatar, {
      email: email,
      vid: Number(contactId),
      size: "sm",
      getAvatarsApi: apiWrapper.getAvatars,
      portalId: portalId,
      type: "contact"
    }),
    itemRight: /*#__PURE__*/_jsx(RadioInput, {
      checked: checked
    }),
    padding: "300",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
      children: [name && /*#__PURE__*/_jsx(TruncateString, {
        matchContentWidth: true,
        children: name
      }), email && /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(TruncateString, {
          matchContentWidth: true,
          children: email
        })
      })]
    })
  });
}
export default SuggestionsListRow;